import React from 'react';
import Navbar2 from '../Components/Navbar2';
import BlogContent from '../Components/Blog/BlogContent';
import FooterSection from '../Components/Homepage2/FooterSection';
import PageSEO from '../Components/SEO/PageSEO';
import PersistentCTA from '../Components/CRO/PersistentCTA';
import StickyMobileCTA from '../Components/CRO/StickyMobileCTA';

const Blog = () => {
  return (
    <>
      <PageSEO 
        title="Top Digital Marketing Agency In Ramamurthy Nagar | Cyborgsapient Pvt. Ltd."
        description="Cyborgsapient Pvt. Ltd. is a leading digital marketing agency in Ramamurthy Nagar, offering SEO, PPC, social media, and growth-driven marketing solutions."
        keywords="digital marketing agency in bangalore, digital marketing agency in ramamurthy nagar, digital marketing blog ramamurthy nagar, marketing insights"
        url="https://cyborgsapient.com/blog"
      />
      <Navbar2 />
      <BlogContent />
      <FooterSection />
      <PersistentCTA />
      <StickyMobileCTA />
    </>
  );
};

export default Blog;
